// extracted by mini-css-extract-plugin
export default {"page-container":"PageContainer_page-container__8IYBy","page-body":"PageContainer_page-body__Ve8X0"};